'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DialogCard = require('./DialogCard.scss');

var _DialogCard2 = _interopRequireDefault(_DialogCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogCard = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DialogCard, _Component);

  function DialogCard() {
    (0, _classCallCheck3.default)(this, DialogCard);
    return (0, _possibleConstructorReturn3.default)(this, (DialogCard.__proto__ || (0, _getPrototypeOf2.default)(DialogCard)).apply(this, arguments));
  }

  (0, _createClass3.default)(DialogCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          message = _props.message,
          children = _props.children;

      return _react2.default.createElement(
        'div',
        { className: _DialogCard2.default.dialogCard },
        _react2.default.createElement(
          'div',
          { className: _DialogCard2.default.title },
          title
        ),
        message && _react2.default.createElement(
          'div',
          { className: _DialogCard2.default.message },
          message
        ),
        children && _react2.default.createElement(
          'div',
          { className: _DialogCard2.default.childrenContainer },
          children
        )
      );
    }
  }]);
  return DialogCard;
}(_react.Component), _class.propTypes = {
  title: _react.PropTypes.node.isRequired,
  message: _react.PropTypes.node,
  children: _react.PropTypes.node
}, _temp);
exports.default = DialogCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DialogCard/DialogCard.js
// module id = 1949
// module chunks = 0